// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"2f4150a3","558":"8bea3b48","826":"bd1d9d0e","935":"bd1d9d0e"}[chunkId] + ".chunk.css";
};